var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersLimitReached(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 75,
    viewBox: "0 0 92 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.9355,
    cy: 25.5215,
    r: 24.6152,
    fill: "#EA8685",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8837 30.6612L68.7053 16.349C68.5269 16.0343 68.2683 15.7726 67.9558 15.5905C67.6434 15.4084 67.2881 15.3125 66.9265 15.3125C66.5648 15.3125 66.2096 15.4084 65.8971 15.5905C65.5846 15.7726 65.326 16.0343 65.1477 16.349L56.9693 30.6612C56.789 30.9733 56.6945 31.3276 56.6953 31.6881C56.6961 32.0486 56.7922 32.4024 56.9738 32.7138C57.1555 33.0251 57.4162 33.283 57.7296 33.4611C58.0429 33.6392 58.3979 33.7313 58.7583 33.7281H75.1151C75.4738 33.7277 75.8261 33.633 76.1366 33.4534C76.4472 33.2738 76.705 33.0156 76.8842 32.7049C77.0634 32.3941 77.1577 32.0417 77.1576 31.683C77.1575 31.3242 77.063 30.9718 76.8837 30.6612Z",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 21.4609V25.5501",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 29.6406H66.9478",
    stroke: "#FD3757",
    strokeWidth: 2.0446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.526 67.597C44.526 62.4016 42.4622 57.419 38.7885 53.7454C35.1148 50.0717 30.1322 48.0078 24.9368 48.0078C19.7415 48.0078 14.7589 50.0717 11.0852 53.7454C7.41151 57.419 5.34766 62.4016 5.34766 67.597",
    stroke: "#0F172A",
    strokeWidth: 4.8973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9347 48.0021C31.6964 48.0021 37.1779 42.5206 37.1779 35.7589C37.1779 28.9971 31.6964 23.5156 24.9347 23.5156C18.1729 23.5156 12.6914 28.9971 12.6914 35.7589C12.6914 42.5206 18.1729 48.0021 24.9347 48.0021Z",
    stroke: "#0F172A",
    strokeWidth: 4.8973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3184 65.1474C54.3184 56.8954 49.4211 49.2311 44.5238 45.5582C46.1336 44.3504 47.4208 42.7645 48.2716 40.9407C49.1224 39.1169 49.5105 37.1115 49.4015 35.1019C49.2926 33.0924 48.6899 31.1407 47.647 29.4196C46.604 27.6985 45.1528 26.261 43.4219 25.2344",
    stroke: "#0F172A",
    strokeWidth: 4.8973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLimitReached);
export default __webpack_public_path__ + "static/media/UsersLimitReached.f8a858fa3d7a7d71af7cafbf55011277.svg";
export { ForwardRef as ReactComponent };